import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslationModule } from '@galaxy/crm/static';

const CRM_ROUTES: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(CRM_ROUTES), TranslationModule],
  exports: [RouterModule],
  providers: [],
})
export class CrmYeswareActionsModule {}
